import { resolveLayerKey } from './layerKeys';

const LS_PREFIX = 'mdv-session';

function sessionKey(projectName) {
  return `${LS_PREFIX}:${String(projectName || 'default')}`;
}

export function readSession(projectName) {
  try {
    const raw = localStorage.getItem(sessionKey(projectName));
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return null;
    return data;
  } catch {
    return null;
  }
}

export function writeSession(projectName, data) {
  try {
    const prev = readSession(projectName) || {};
    localStorage.setItem(
      sessionKey(projectName),
      JSON.stringify({
        ...prev,
        ...data,
        savedAt: new Date().toISOString(),
      })
    );
  } catch {
    // quota or private mode
  }
}

export function clearSession(projectName) {
  try {
    localStorage.removeItem(sessionKey(projectName));
  } catch {
    // ignore
  }
}

export function opacityMapFromLayers(layerVisibility) {
  const opacity = {};
  Object.keys(layerVisibility || {}).forEach((key) => {
    const o = layerVisibility[key]?.opacity;
    if (typeof o === 'number' && o !== 1) opacity[key] = o;
  });
  return opacity;
}

export function readIsolatedKeys(data) {
  if (Array.isArray(data?.isolatedKeys)) {
    return data.isolatedKeys.filter((k) => typeof k === 'string' && k.length > 0);
  }
  if (typeof data?.isolatedKey === 'string' && data.isolatedKey) {
    return [data.isolatedKey];
  }
  return [];
}

export function sessionHasVisibleList(session) {
  return Array.isArray(session?.visible) && session.visible.length > 0;
}

export function savedVisibleIncludes(session, modelList, modelName) {
  const keys = session?.visible;
  if (!Array.isArray(keys) || !modelName) return false;
  return keys.some((id) => id === modelName || resolveLayerKey(modelList, id) === modelName);
}

/** True when every catalogue/query layer already has a layerVisibility entry. */
export function layerVisibilityCoversModelList(layerVisibility, modelList) {
  const vis = layerVisibility || {};
  for (const group of modelList || []) {
    for (const model of group.models || []) {
      if (model?.name && !vis[model.name]) return false;
    }
  }
  return true;
}

export function cachedKeysFromLayers(layerVisibility) {
  return Object.keys(layerVisibility || {}).filter(
    (k) => layerVisibility[k]?.loadStatus === 'ready' || layerVisibility[k]?.diskCached
  );
}

export function readCachedKeys(session) {
  if (Array.isArray(session?.cached)) {
    return session.cached.filter((k) => typeof k === 'string' && k.length > 0);
  }
  return [];
}

export function preserveUnloadedVisibleKeys(existingVisible, layerVisibility, modelList) {
  const known = new Set(Object.keys(layerVisibility || {}));
  return (existingVisible || []).filter((id) => {
    if (typeof id !== 'string' || !id) return false;
    if (known.has(id)) return false;
    const resolved = resolveLayerKey(modelList, id);
    if (resolved && known.has(resolved)) return false;
    return true;
  });
}
